const propertyWithValue = (
	value,
	enumerable = false,
	configurable = false,
	writable = false
) => {
	const desc = propertyWithValue.d || (
		propertyWithValue.d = {
			enumerable: enumerable,
			writable: writable,
			configurable: configurable,
			value: null
		});
	desc.value = value;
	return desc;
};

class Point {
	constructor(x, y) {
		Object.defineProperty(this, 'x', propertyWithValue(x));
		Object.defineProperty(this, 'y', propertyWithValue(y));
		Object.freeze(this);
	}

	equals(point) { return point.x === this.x && point.y === this.y; }
}

class Size {
	constructor(width, height) {
		Object.defineProperty(this, 'width', propertyWithValue(width));
		Object.defineProperty(this, 'height', propertyWithValue(height));
		Object.freeze(this);
	}
}

class Rect {
	constructor(x, y, width, height) {
		Object.defineProperty(this, 'x', propertyWithValue(x));
		Object.defineProperty(this, 'y', propertyWithValue(y));
		Object.defineProperty(this, 'width', propertyWithValue(width));
		Object.defineProperty(this, 'height', propertyWithValue(height));
		Object.defineProperty(this, 'origin', propertyWithValue(new Point(x, y)));
		Object.defineProperty(this, 'size', propertyWithValue(new Size(width, height)));
		Object.freeze(this);
	}

	get center() { return new Point(this.midX, this.midY); }

	get midX() { return this.x + this.width / 2; }

	get midY() { return this.y + this.height / 2; }
}

export { Point, Size, Rect };


// WEBPACK FOOTER //
// ./src/js/utils/geometry.js